import AppDispatcher from '../dispatcher/AppDispatcher';
import AccountsPreferenceConstants from '../constants/AccountsPreferenceConstants';
import StatementsPreferencesParser from '../parsers/StatementsPreferencesParser';

class StatementsPreferencesActionCreator {
  /*
   ** Action to fetch statement preferences for accounts
   */
  getPreferences() {
    AppDispatcher.handleViewAction({
      actionType: AccountsPreferenceConstants.REQUEST_STATEMENT_PREFERENCES,
    });
  }

  /*
   ** Action to set the reference of the module to get to the back page
   */
  setBackPageReference(urlString) {
    AppDispatcher.handleViewAction({
      actionType: AccountsPreferenceConstants.STATEMENT_BACKPAGE_REFERENCE,
      urlString,
    });
  }

  /*
   ** Action to set the statement preferences
   */
  setStatementPreference(request) {
    AppDispatcher.handleViewAction({
      actionType: AccountsPreferenceConstants.SET_STATEMENT_PREFERENCES,
      data: request,
    });
  }

  /*
   ** Server Actions
   ** server action of success scenario of statement preferences
   */
  handleStatementPreferenceSuccess(response, flag) {
    const stmtData =
      StatementsPreferencesParser.statementPreferencesParser(response);
    AppDispatcher.handleServerAction({
      actionType:
        AccountsPreferenceConstants.REQUEST_STATEMENT_PREFERENCES_SUCCESS,
      data: stmtData,
      setStmtFlag: flag,
    });
  }

  /*
   **  server action of error scenario of statement preferences
   */
  handleStatementPreferenceError(error) {
    AppDispatcher.handleServerAction({
      actionType:
        AccountsPreferenceConstants.REQUEST_STATEMENT_PREFERENCES_ERROR,
      error,
    });
  }
}

export default new StatementsPreferencesActionCreator();
